import { translate } from './translation';
import { ActivityType, TripType } from '../types';

export const activityTypeDisplayStrings = {
  [ActivityType.Uncertain]: translate('UNCERTAIN_ACTIVITY'),
  [ActivityType.Reposition]: translate('REPOSITION_ACTIVITY'),
  [ActivityType.Sailing]: translate('SAILING_ACTIVITY'),
  [ActivityType.Shifting]: translate('SHIFTING_ACTIVITY'),
  [ActivityType.Berthing]: translate('BERTHING_ACTIVITY'),
  [ActivityType.Demobilization]: translate('DEMOBILIZATION_ACTIVITY'),
  [ActivityType.Mobilization]: translate('MOBILIZATION_ACTIVITY'),
  [ActivityType.Redeployment]: translate('REDEPLOYMENT_ACTIVITY'),
  [ActivityType.Resting]: translate('RESTING_ACTIVITY'),
  [ActivityType.Waiting]: translate('WAITING_ACTIVITY'),
  [ActivityType.SignalLost]: translate('SIGNAL_LOST'),
  [ActivityType.Loading]: translate('LOADING_ACTIVITY'),
};

export const tripTypeDisplayStrings = {
  [TripType.Uncertain]: translate('UNCERTAIN'),
  [TripType.Berthing]: translate('BERTHING'),
  [TripType.Repositioning]: translate('REPOSITIONING'),
  [TripType.Sailing]: translate('SAILING'),
  [TripType.Shifting]: translate('SHIFTING'),
  [TripType.Resting]: translate('RESTING'),
};

export const secretNames = {
  appInsightsInstrumentationKey: 'frontend-instrumentationKey',
  mapboxToken: 'frontend-mapboxToken',
};

export const externalLinks = {
  aimFor8Report:
    'https://app.powerbi.com/groups/me/apps/0969d354-79a8-4e1f-bd86-42cfaf12892c/reports/c1756d69-5d07-41f8-8853-d1fccdeaac07/',
  requestNewOperationForm:
    'https://forms.office.com/Pages/ResponsePage.aspx?id=dJrlvak15EOlyfQ00rB2UxTNCrOIUqJNlDl8enekcE5UMDYxNEE4TTQ5WldXN1VMQ1k0QTRMRzlZTiQlQCN0PWcu',
  openSeaMap: 'https://tiles.openseamap.org/seamark/{z}/{x}/{y}.png',
};
